import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class RegisterGuard {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const productId = route.queryParams['product_id'];
    const billingCycle = route.queryParams['billingcycle'];
    let signupUrl = environment.signupUrl;

    if (productId || billingCycle) {
      const url = new URL(signupUrl);
      if (productId) {
        url.searchParams.append('product_id', productId);
      }
      if (billingCycle) {
        url.searchParams.append('billingcycle', billingCycle);
      }
      signupUrl = url.toString();
    }
    
    window.location.href = signupUrl;
    return false;
  }
}
